
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: {
      type: String,
      default: "详情",
    },
    colors: {
      type: Array,
      default: () => [],
    },
    currentVal: {
      type: Number,
      default: 0,
    },
    currentDt: {
      type: String,
      default: "-",
    },
    compareVal: {
      type: Number,
      default: null,
    },
    compareDt: {
      type: String,
      default: "-",
    },
  },
});
